// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1dJ-G","bigColWidth":"Table_bigColWidth__XRMo0","biggerColWidth":"Table_biggerColWidth__2pmG_","row":"Table_row__Pb3_9","col":"Table_col__-JVyI"};